import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate, useParams } from 'react-router-dom'
import { MasterLayout } from '../../_dashboard/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_dashboard/assets/ts/_utils'
import { ID, WithChildren } from '../../_dashboard/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import HotelsPage from '../pages/hotel-management/HotelsPage'
import { HotelDetailsPage } from '../pages/hotel-management/hotel-details/HotelDetails'
import ReservationsPage from '../pages/reservation-management/ReservationPage'
import { ReservationDetailsPage } from '../pages/reservation-management/reservation-details/ReservationDetails'

import FooterPage from '../pages/footer-management/FooterPage'
import HeaderPage from '../pages/header-management/HeaderPage'
import ContactPage from '../pages/contact-management/ContactPage'
import AboutPage from '../pages/about-management/AboutPage'
import FacilityPage from '../pages/facilities-managment/FacilitiesPage'
import ThemesPage from '../pages/themes-managment/ThemesPage'
import OptionPage from '../pages/options-managment/OptionPage'
import BookingExtraPage from '../pages/booking-extras-managment/BookingExtraPage'
import CmsServicePage from '../pages/services-management/CmsServicePage'
import AgenciesPage from '../pages/agencies-managment/AgencyPage'
import PaymentMethodsPage from '../pages/payment-methods-managment/PaymentMethodPage'
import PagesPage from '../pages/pages-managment/PagesPage'
import { PageInfo } from '../pages/pages-managment/pages-details/PageInfo'
import NewsletterPage from '../pages/newsletter-management/NewsletterPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../pages/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/apps/hotel-management/hotels' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/hotel-management/*'
          element={
            <SuspensedView>
              <HotelsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/reservation-management/*'
          element={
            <SuspensedView>
              <ReservationsPage />
            </SuspensedView>
          }
        />

        <Route path="/hotel/:id" element={<HotelDetailsPage />} />
        <Route path="/reservation/:id" element={<ReservationDetailsPage />} />

        <Route
          path='apps/footer-management/*'
          element={
            <SuspensedView>
              <FooterPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/header-management/*'
          element={
            <SuspensedView>
              <HeaderPage />
            </SuspensedView>
          }
        />
 <Route
          path='apps/Contact-management/*'
          element={
            <SuspensedView>
              <ContactPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/about-management/*'
          element={
            <SuspensedView>
              <AboutPage />
            </SuspensedView>
          }
        />
           <Route
          path='apps/facilities-management/*'
          element={
            <SuspensedView>
              <FacilityPage />
            </SuspensedView>
          }
        />
            <Route
          path='apps/themes-management/*'
          element={
            <SuspensedView>
              <ThemesPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/OPTIONS-management/*'
          element={
            <SuspensedView>
              <OptionPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/booking-extras-management/*'
          element={
            <SuspensedView>
              <BookingExtraPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/services-management/*'
          element={
            <SuspensedView>
              <CmsServicePage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/agencies-management/*'
          element={
            <SuspensedView>
              <AgenciesPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/payment-methods-management/*'
          element={
            <SuspensedView>
              <PaymentMethodsPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/pages-management/*'
          element={
            <SuspensedView>
              <PagesPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/newsletter-management/*'
          element={
            <SuspensedView>
              <NewsletterPage />
            </SuspensedView>
          }
        />
        <Route path='pages/:id' element={<PageInfo id={useParams().id! as unknown as ID} />} />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
